export default {
    indexModule: { method: 'get', url: 'emcadmin/modules' },
    storeModule: { method: 'post', url: 'emcadmin/modules' },
    updateModule: { method: 'put', url: 'emcadmin/modules/{id}'},
    destroyModule: { method: 'delete', url: 'emcadmin/modules/{id}'},
    showTimeSheet:      { method: 'get',    url: 'process_time_sheet/show_time_sheet' },
}